/*
 * Copyright (c) 2024 metromorph softworks GmbH
 *
 * All rights reserved
 */

import {
    App,
    AppConfig,
} from "@ef/common-app";

import {
    AppScreen,
    setNotice,
    clearNotice,
    loadScreen,
    loadAppConfiguration
} from "@ef/feature-app";

import { initLogin as initLoginAction } from "@ef/feature-login";

import { TplEditScreenLoader } from "@ef/components-lettertemplate/ScreenSpec";
import { 
    initLogin,
    initControllers, 
} from "./config";

const config = {
    initializers: [
        async (store) => {
            store.dispatch(setNotice("Init controllers"));
            initControllers();
            store.dispatch(clearNotice());
        },
        async (store) => {
            store.dispatch(setNotice("Register screens"));
            // Import screens to register routes
            // Done here (not at module level) to avoid conflicts in multi-app tests
            await import("./screens");
            store.dispatch(clearNotice());
        },
        async (store) => {
            const appConfig = await store
                .dispatch(
                    loadAppConfiguration("./appconfig.json")
                )
                .unwrap()
            ;
            if (appConfig) {
                initLogin(appConfig);
            }
        },
        async (store) => {
            store.dispatch(setNotice("Init login"));
            await store.dispatch(initLoginAction());
            store.dispatch(clearNotice());
        },
        async (store) => {
            store.dispatch(setNotice("Load TplEditScreen (Default)..."));
            const screen = {
                ...(TplEditScreenLoader().screen),
                name: "USER_DEFAULT"
            } as AppScreen;
            await store.dispatch(loadScreen({
                screen,
                force: true,
                preload: true
            }));
            store.dispatch(clearNotice());
        }
    ],
    logStore: (typeof process != "undefined" ?
        (process.env.LOG_REDUX as string)?.toUpperCase()
        : false
    )
} as AppConfig;

const TplEditApp = new App(config);

export default TplEditApp;
